import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home'
import HomeEmpresa from '../views/HomeEmpresa'
import Zap from '../views/Zap'
import NotFound from '../views/NotFound'
import Login from '../views/Login'
import Sucesso from '../views/Sucesso'

import Categorias from '../../../pages/Categorias'
import InfoRestaurante from '../../../pages/InfoRestaurante'
import Finalizar from '../../../pages/Finalizar'
import Sacola from '../../../pages/Sacola'
import Promocoes from '../../../pages/Promocoes'
import Pedidos from '../../../pages/Pedidos'
import Perfil from '../../../pages/Perfil'
import MeusCartoes from '../../../pages/MeusCartoes'
import Ajuda from '../../../pages/Ajuda'
import ExcluirConta from '../../../pages/ExcluirConta'
import Notificacao from '../../../pages/Notificacao'
import PerfilDados from '../../../pages/PerfilDados'
import PerfilEndereco from '../../../pages/PerfilEndereco'
import PerfilEsqueceuSenha from '../../../pages/PerfilEsqueceuSenha'
import PerfilWhatsapp from '../../../pages/PerfilWhatsapp'
import NoLocal from '../../../pages/NoLocal'
import LeCard from '../../../pages/LeCard'
import Links from '../../../pages/Links'
import MeusPontos from '../../../pages/MeusPontos'
import MeusVouchers from '../../../pages/MeusVouchers'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomeGo',
    component: Home
  },
  {
    path: '/lecard-go',
    name: 'LeCardGo',
    component: LeCard
  },
  {
    path: '/m/:hash',
    name: 'Zap',
    component: Zap
  },
  {
    path: '/m/:hash/menu',
    name: 'ZapMenu',
    component: Zap
  },
  {
    path: '/404',
    name: 'NotFound',
    component: NotFound
  },
  {
    path: '/:id',
    name: 'HomeEmpresa',
    component: HomeEmpresa
  },
  {
    path: '/:id/home',
    name: 'Home',
    component: HomeEmpresa
  },
  {
    path: '/:id/categorias',
    name: 'Categorias',
    component: Categorias
  },
  {
    path: '/:id/info',
    name: 'InfoRestaurante',
    component: InfoRestaurante
  },
  {
    path: '/:id/finalizar',
    name: 'Finalizar',
    component: Finalizar
  },
  {
    path: '/:id/sacola',
    name: 'Sacola',
    component: Sacola
  },
  {
    path: '/:id/promocoes',
    name: 'Promocoes',
    component: Promocoes
  },
  {
    path: '/:id/pedidos',
    name: 'Pedidos',
    component: Pedidos
  },
  {
    path: '/:id/sucesso',
    name: 'Sucesso',
    component: Sucesso
  },
  {
    path: '/:id/ajuda',
    name: 'Ajuda',
    component: Ajuda
  },
  {
    path: '/:id/excluir-conta',
    name: 'ExcluirConta',
    component: ExcluirConta
  },
  {
    path: '/:id/notificacao',
    name: 'Notificacao',
    component: Notificacao
  },
  {
    path: '/:id/perfil',
    name: 'Perfil',
    component: Perfil
  },
  {
    path: '/:id/perfil/whatsapp',
    name: 'PerfilWhatsapp',
    component: PerfilWhatsapp
  },
  {
    path: '/:id/perfil/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/:id/perfil/login/whatsapp',
    name: 'LoginWhatsapp',
    component: PerfilWhatsapp
  },
  {
    path: '/:id/perfil/cadastro',
    name: 'Cadastro',
    component: PerfilDados
  },
  {
    path: '/:id/perfil/esqueci-senha',
    name: 'EsqueceuSenha',
    component: PerfilEsqueceuSenha
  },
  {
    path: '/:id/perfil/esqueci-senha-whatsapp',
    name: 'EsqueceuSenhaWhatsapp',
    component: PerfilWhatsapp
  },
  {
    path: '/:id/perfil/enderecos',
    name: 'PerfilEndereco',
    component: PerfilEndereco
  },
  {
    path: '/:id/perfil/meus-dados',
    name: 'MeusDados',
    component: PerfilDados
  },
  {
    path: '/:id/perfil/telefone',
    name: 'Telefone',
    component: PerfilDados
  },
  {
    path: '/:id/perfil/meus-pontos',
    name: 'MeusPontos',
    component: MeusPontos
  },
  {
    path: '/:id/perfil/meus-vouchers',
    name: 'MeusVouchers',
    component: MeusVouchers
  },
  {
    path: '/perfil/meus-cartoes',
    name: 'MeusCartoes',
    component: MeusCartoes
  },
  {
    path: '/:id/nolocal',
    name: 'NoLocal',
    component: NoLocal
  },
  {
    path: '/:id/links',
    name: 'Links',
    component: Links
  },
  {
    path: '/:id/fidelidade',
    name: 'Fidelidade',
    component: Promocoes
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
